export const updateEmpList = (payload) => ({
  type: "UP_EMP_LIST",
  payload,
});

export const setEmpList = (payload) => ({
  type: "SET_EMP",
  payload,
});

export const setMedList = (payload) => ({
  type: "SET_MED",
  payload,
});
export const setOrders = (payload) => ({
  type: "SET_ORDER",
  payload,
});
export const setIsAdmin = (payload) => ({
  type: "SET_IS_ADMIN",
  payload,
});
export const setIsSale = (payload) => ({
  type: "SET_IS_SALE",
  payload,
});
export const setAdminCred = (payload) => ({
  type: "SET_CRED_ADMIN",
  payload,
});
export const setSalesCred = (payload) => ({
  type: "SET_CRED_SALE",
  payload,
});
